import { AddressDto } from "../address/address.dto";
import { YandexAddressDto } from "../address/yandex-address.dto";

export class CustomerObjectWithContactsDto {
    customerObjectId: number;
    name: string;
    address: string;
    addressDescription: string;
    contragentId: number;
    contragentName: string;
    latitude: number;
    longitude: number;

    addressInfo: AddressDto;
    contacts: CustomerObjectContactDto[] = [];
    serviceCenterId: number;
    serviceCenterName: string;

    yandexModel: YandexAddressDto;

    ignoreAddressCheck: boolean = false;
}

export class CustomerObjectContactDto {
    contactId: number;
    fullName: string;
    phoneNumber: string;
    email: string;
    isContragentContact: boolean;
}

export const CONTRAGENT_CONTACT_FALLBACK_NAME = 'Контактный телефон клиента';

export function getContragentContactDisplayName(contragentName: string, contact: CustomerObjectContactDto): string {
    if (contragentName && contragentName.trim()) {
        return contragentName.trim();
    }

    if (contact && contact.fullName && contact.fullName.trim()) {
        return contact.fullName.trim();
    }

    return CONTRAGENT_CONTACT_FALLBACK_NAME;
}